<template>
    <input
        ref="input"
        class="pl-2 border-gray-300 focus:border-green-500 rounded-md focus:ring-green-200 focus:ring-opacity-5 shadow-sm"
        :value="value"
        @input="$emit('input', $event.target.value)"
    />
</template>

<script>
    export default {
        props: ['value'],

        methods: {
            focus() {
                if (this.$refs.input) {
                    this.$refs.input.focus();
                }
            },
        },
    };
</script>
